import React from 'react';
import { components } from 'react-select';

const MultiselectCheckbox = (props) => {
    console.log(props, "****&&&&")
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null} // Prevent React from complaining about missing onChange
        />
        <label style={{marginLeft: '10px', marginBottom: 0}}>{props.label}</label>
      </div>
    </components.Option>
  );
};

export default MultiselectCheckbox;
